import { getTicketInfo } from 'api/ticketgeneratorpage';
import type { TicketResponse } from 'api/responseTypes';
import type { AxiosError } from 'axios';
import { useQuery } from 'react-query';

export const useTicketQuery = (id?: string) => {
  if (!id) {
    throw Error('No ticket id found!');
  }

  const { data, isFetching, error } = useQuery<
    TicketResponse,
    AxiosError<{ statusCode?: number; message?: string }>
  >(`ticket-${id}`, async () => await getTicketInfo(id));

  return { data, isFetching, error };
};
